import { GAS_DEFAULTS } from './constants';

export const calculateConsumption = (oldReading, newReading, meter) => {
  if (!oldReading || !newReading) return null;
  
  const oldValue = parseFloat(oldReading.value);
  const newValue = parseFloat(newReading.value);
  
  if (isNaN(oldValue) || isNaN(newValue)) return null;
  
  const diff = newValue - oldValue;
  
  if (diff < 0) return null; // Invalid: new reading lower than old
  
  if (meter.type === 'gas') {
    // Use reading-specific gas params if available, otherwise meter params, otherwise defaults
    const zNumber = newReading.gasParams?.zNumber || 
                    meter.params?.zNumber || 
                    GAS_DEFAULTS.zNumber;
    const heatingValue = newReading.gasParams?.heatingValue || 
                         meter.params?.heatingValue || 
                         GAS_DEFAULTS.heatingValue;
    
    if (!zNumber || !heatingValue || zNumber === 0 || heatingValue === 0) {
      return null; // Return null if gas params are missing/invalid
    }
    
    return diff * zNumber * heatingValue;
  }
  
  // For electricity and water, return diff directly (electricity is already in kWh)
  // Water stays in m³ but we treat it as consumption value
  return diff;
};

export const extrapolateToYear = (consumption, days) => {
  if (!consumption || !days || days === 0) return null;
  return (consumption / days) * 365;
};

export const calculatePeriodStats = (reading1, reading2, meter) => {
  const consumption = calculateConsumption(reading1, reading2, meter);
  
  if (consumption === null) {
    return {
      days: 0,
      consumption: 0,
      perDay: 0,
      yearlyForecast: 0,
      error: 'Ungültige Daten oder fehlende Gas-Parameter'
    };
  }
  
  const time1 = new Date(reading1.timestamp).getTime();
  const time2 = new Date(reading2.timestamp).getTime();
  const days = Math.abs(time2 - time1) / (1000 * 60 * 60 * 24);
  
  if (days === 0) {
    return {
      days: 0,
      consumption,
      perDay: 0,
      yearlyForecast: 0,
      error: 'Zeitraum ist 0 Tage - bitte wählen Sie Ablesungen mit zeitlichem Abstand'
    };
  }
  
  const perDay = consumption / days;
  const yearlyForecast = extrapolateToYear(consumption, days);
  
  return {
    days: Math.round(days * 10) / 10,
    consumption: Math.round(consumption * 100) / 100,
    perDay: Math.round(perDay * 100) / 100,
    yearlyForecast: Math.round(yearlyForecast * 100) / 100,
    error: null
  };
};